// Sky: raymarched daytime clouds with you composited over them. Fully
// procedural; no image layer.
//
// A packaged composite consumers can list by importing this module.
//
// Native variant. The thumbnail is the string id the prebuild plugin
// (app.plugin.js) bundles `clouds.thumb.webp` as into the native app target;
// `resolveImageUri` looks it up in Bundle.main. The web sibling (clouds.web.ts)
// keeps the `Asset.fromModule(...).uri` pattern; mirrors the other composites.

import type { KaleidoscopePreset } from '../../../src/kaleidoscope.preset-book.types';

export const clouds = {
  name: 'Daytime',
  taxonomy: ['Shaders', 'Sky'],
  thumbnail: 'clouds-thumb',
  layers: [
    {
      id: 'sky',
      shader: 'clouds',
      uniforms: {
        uSkyLowColor: [0.09, 0.63, 0.95],
        uSkyHighColor: [0.04, 0.03, 0.86],
        uCloudLightColor: [1.0, 0.91, 0.77],
        uCloudDarkColor: [0.3, 0.3, 0.5],
        uExposure: 1.27,
        uStepSize: 0.16,
        uCloudSpeed: 0.52,
        uCloudScale: 1.08,
        uDensity: 0.245,
        uCoverage: 0.47,
        uSoftness: 0.28,
      },
    },
    // You, under the sky.
    { id: 'you', shader: 'direct', target: 'subject' },
  ],
} as const satisfies KaleidoscopePreset;
